module.exports = __webpack_public_path__ + "static/img/5bg_7.3dfe144.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/5bg_7.png
// module id = 723
// module chunks = 1